import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-c3d20b74"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "wrapper-container"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("img", {
    width: 232,
    src: "https://hetao-contest.oss-cn-beijing.aliyuncs.com/cdn/lottie/check.png",
    alt: "logo"
  }, null, -1);
});
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("h3", {
    class: "title"
  }, "请完成考前环境检测", -1);
});
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "desc"
  }, [/*#__PURE__*/_createElementVNode("span", null, " 为保证您的考试顺利进行，请完成考前环境检测，约耗时 "), /*#__PURE__*/_createElementVNode("span", {
    class: "hl"
  }, "3分钟")], -1);
});
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    style: {
      "margin-left": "6px"
    }
  }, "开始检测", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_CaretRightOutlined = _resolveComponent("CaretRightOutlined");
  var _component_a_button = _resolveComponent("a-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _hoisted_4, _createVNode(_component_a_button, {
    type: "primary",
    size: "large",
    shape: "round",
    onClick: _ctx.startCheck
  }, {
    default: _withCtx(function () {
      return [_hoisted_5, _createVNode(_component_CaretRightOutlined)];
    }),
    _: 1
  }, 8, ["onClick"])]);
}